// @flow

import {Environment} from 'relay-runtime'
import {commitMutation, graphql, } from 'react-relay'

const addMutation = graphql`
    mutation TVShowEpisodeAddMutation(
        $input: TVShowEpisodeAddInput!
    ) {
        TVShowEpisodeAdd(input: $input) {
            tVShowEpisodeEdge {
                node {
                    id
                }
            }
        }
    }
`

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
    commitMutation(
        environment, 
        {
            mutation: addMutation,
            variables: {
                input: params
            },
            onCompleted: (response) =>{
                if (response.error !== null && response.error !== undefined) {
                    callback(response.error, null)
                    return
                }

                if (callback) {
                    callback(null, response.TVShowEpisodeAdd.tVShowEpisodeEdge.node.id)
                }
            },
            onError: (error) => {
                if (callback) {
                    callback(error, null)
                }
            },
        })
}


// WEBPACK FOOTER //
// src/mutations/TVShowEpisodeAddMutation.js